
import GoogleUserDetails from 'models/GoogleUserDetails';

import Component from './component';

export interface Props {
    headline?: string;
    onSuccess: (gCredential: string, googleUserDetails: GoogleUserDetails) => void;
    onError: () => void;
}

Component.defaultProps = {
    headline: null,
    onSuccess: null,
    onError: null,
};
export default Component;